import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './ui/__generated__/RichTextPopUpContentQuery$parameters';

type EntryPointParams = { issueKey: string; fieldId: string; cloudId: string };

export const richTextPopUpContentEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-rich-text-content" */ './ui/RichTextPopUpContent.tsx'),
	),
	getPreloadProps: ({ issueKey, fieldId, cloudId }: EntryPointParams) => ({
		queries: {
			richTextContent: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					issueKey,
					fieldId,
					cloudId,
				},
			},
		},
		extraProps: {
			issueKey,
		},
	}),
});
